module.exports = __webpack_public_path__ + "assets/arrow-left-dark-9957c762eb1db0e4d044699bb1409292.svg";